import { useEffect, useState } from 'react';
import { ZAPP_STORAGE_UPDATED_EVENT } from '~/hooks/actions/defaultActions/sessionStorageSet';
import { getActiveProfileIdFromStorage } from '~/services/queue/setup-client-queue';

/**
 * Reads the active profile id from storage and refreshes on profile switches.
 *
 * @returns Active profile id, or null when none is set.
 */
export function useActiveProfileId(): string | null {
  const [activeProfileId, setActiveProfileId] = useState<string | null>(null);

  useEffect(() => {
    const refresh = (): void => {
      setActiveProfileId(getActiveProfileIdFromStorage());
    };

    refresh();

    window.addEventListener('storage', refresh);
    window.addEventListener(ZAPP_STORAGE_UPDATED_EVENT, refresh);

    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener(ZAPP_STORAGE_UPDATED_EVENT, refresh);
    };
  }, []);

  return activeProfileId;
}
